import './i18n';

export const translateOrFallback = require('./keys').translateOrFallback;

export function toI18N(key: string) {
    const value = translateOrFallback(key);
    return (value || key).toString();
}

export function formatI18nKeys(key: string, ...args: Array<any>): string {
    let value = translateOrFallback(key);
    if (!value) {
        return key;
    }
    for (let i = 0; i < args.length; i++) {
        let varIndex = i + 1;
        value = value.replace(`%${varIndex}$s`, args[i]);
    }
    return value;
}
